/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */
import { useEffect } from 'react';
import createFocusTrap from 'focus-trap';
export var useFocusTrap = function useFocusTrap(_ref) {
  var targetRef = _ref.targetRef,
    initialFocusRef = _ref.initialFocusRef;
  useEffect(function () {
    if (!targetRef) {
      return;
    }
    var trapConfig = {
      clickOutsideDeactivates: true,
      escapeDeactivates: true,
      initialFocus: initialFocusRef || targetRef,
      fallbackFocus: targetRef,
      returnFocusOnDeactivate: false
    };
    var focusTrap = createFocusTrap(targetRef, trapConfig);

    // wait for the popup to reposition itself before we focus
    var frameId = requestAnimationFrame(function () {
      frameId = null;
      focusTrap.activate();
    });
    return function () {
      if (frameId != null) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
      focusTrap.deactivate();
    };
  }, [targetRef, initialFocusRef]);
};